function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var deleteWinnreAuthToken = function deleteWinnreAuthToken(_ref) {
  var winnreAuth = _ref.winnreAuth;
  delete winnreAuth.defaults.headers.common["Authorization"];
};
export var removeSessionTokens = function removeSessionTokens() {
  sessionStorage.removeItem("refreshToken");
  sessionStorage.removeItem("accessToken");
};
export var setSessionTokens = function setSessionTokens(refreshToken, accessToken) {
  sessionStorage.setItem("refreshToken", refreshToken);
  sessionStorage.setItem("accessToken", accessToken);
};
export var setLocalTokens = function setLocalTokens(refreshToken, accessToken) {
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("accessToken", accessToken);
};
export var removeLocalTokens = function removeLocalTokens() {
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("accessToken");
};
export var dispatchUserData = function dispatchUserData(dispatch, user, userRole, authActions) {
  dispatch(authActions.setUserData({
    userDetails: {
      mobileCountryCode: user.mobileCountryCode,
      mobileNumber: user.mobileNumber,
      email: user.email,
      status: user === null || user === void 0 ? void 0 : user.status,
      preferredName: user === null || user === void 0 ? void 0 : user.preferredName,
      birthDate: user === null || user === void 0 ? void 0 : user.dateOfBirth,
      address: user === null || user === void 0 ? void 0 : user.address
    },
    name: user.name,
    userRole: userRole,
    userType: user === null || user === void 0 ? void 0 : user.userType,
    userId: user === null || user === void 0 ? void 0 : user.id,
    hashId: user.hashId,
    profileCompletionPercentage: user === null || user === void 0 ? void 0 : user.profileCompletionPercentage,
    finishedFirstTimeLoginGuide: user === null || user === void 0 ? void 0 : user.finishedFirstTimeLoginGuide
  }));
};
export var webengageLogin = function webengageLogin(user, userRole, isWebView, userToken) {
  var _user$name, _user$name2;
  window.webengage.user.login(user === null || user === void 0 ? void 0 : user.hashId);
  window.webengage.user.setAttribute("we_email", user === null || user === void 0 ? void 0 : user.email);
  window.webengage.user.setAttribute("we_phone", user === null || user === void 0 ? void 0 : user.mobileNumber);
  window.webengage.user.setAttribute("we_first_name", user === null || user === void 0 || (_user$name = user.name) === null || _user$name === void 0 ? void 0 : _user$name.split(" ")[0]);
  window.webengage.user.setAttribute("we_last_name", user === null || user === void 0 || (_user$name2 = user.name) === null || _user$name2 === void 0 ? void 0 : _user$name2.split(" ").pop());
  window.webengage.track("LoggedIn", _objectSpread(_objectSpread({
    ProfileType: "".concat(userRole)
  }, isWebView && {
    Webview: true
  }), userToken && !isWebView && {
    URLLogin: true
  }));
};
export var logoutHandler = function logoutHandler(dispatch, winnreAuth, authActions) {
  var _window, _window2;
  deleteWinnreAuthToken({
    winnreAuth: winnreAuth
  });
  (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("LogOut");
  (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || (_window2 = _window2.user) === null || _window2 === void 0 || _window2.logout();
  dispatch(authActions.logout());
};